<div class="training-section-container">
    <div class="animated-button animated-border" (click)="goToTraining()">
        <div class="animated-button-text">{{'Training_Section_Button' | transformText}}</div>
    </div>
</div>